import { OrderFields } from "../constants";
import useOrderData from "../context/useOrderData";
import useOrderFormik from "./useOrderFormik";

type TOrderCouponReturn = {
  hasCoupon: boolean;
  isValid?: boolean;
  promoCode?: string;
  isBlocked?: boolean;
};

const useOrderCoupon = (): TOrderCouponReturn => {
  const {
    dynamicData: { coupon },
  } = useOrderData();

  const {
    values: { [OrderFields.PROMO_CODE]: currentPromoCode },
  } = useOrderFormik();

  const hasOldCoupon = !!currentPromoCode;
  const isNewCouponSubmitted = !currentPromoCode && !!coupon;

  const isValid = (hasOldCoupon || isNewCouponSubmitted) && !!coupon?.isValid;
  const isBlocked = isNewCouponSubmitted && !!coupon?.isBlocked;
  const promoCode = currentPromoCode || coupon?.promoCode || undefined;

  return {
    hasCoupon: hasOldCoupon || isNewCouponSubmitted,
    isValid,
    promoCode,
    isBlocked,
  };
};
export default useOrderCoupon;
